import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./InsuranceProviders.css";

const InsuranceProviders = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [logosRef, logosVisible] = useScrollAnimation({ threshold: 0.1 });

  const providers = [
    { name: "Manulife", logo: "/network/manulife.png" },
    { name: "Beneva", logo: "/network/beneva.png" },
    { name: "Industrial Alliance", logo: "/network/ia-group.png" },
    { name: "Greenshield", logo: "/network/greenshield.png" },
    { name: "Assumption Life", logo: "/network/assumption-life.png" },
    { name: "Travellers", logo: "/network/travellers.png" },
  ];

  return (
    <section className="insurance-providers">
      <div className="insurance-providers-container">
        <div ref={headerRef} className={`insurance-providers-header ${headerVisible ? "animate-in" : ""}`}>
          <h2 className="insurance-providers-title">Our Network</h2>
          <h3 className="insurance-providers-subtitle">Insurance Providers Available Through Our Network</h3>
          <p className="insurance-providers-description">
            BSquare Financial leverages a broad network of Canada's most recognized insurers. This allows us to remain objective—our recommendations are guided by your data and needs, not by any single carrier.
          </p>
        </div>
        <div ref={logosRef} className={`insurance-providers-logos ${logosVisible ? "animate-in" : ""}`}>
          {providers.map((provider, index) => (
            <div key={index} className="provider-logo">
              <img src={provider.logo} alt={provider.name} className="logo-image" />
            </div>
          ))}
        </div>
        <p className="insurance-providers-note">
          Insurance products are offered through Experior Financial Group Inc. Availability varies by insurer, province, and individual eligibility.
        </p>
      </div>
    </section>
  );
};

export default InsuranceProviders;
